import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Plan } from "../../Graphql/types/plan";

/** Plan + resolved price/billing for checkout (order summary & success) */
export interface SelectedPlanForCheckout extends Plan {
  price: number;
  currency: string;
  billingCycle: string;
  billingCycleId?: string;
  durationValue?: number;
  durationUnit?: "DAY" | "MONTH" | "YEAR";
}

export interface PlanState {
  planList: Plan[];
  planDetail: Plan | null;
  /** Set when user selects a plan to go to order summary; used when location.state is lost (e.g. in container) */
  selectedPlanForCheckout: SelectedPlanForCheckout | null;
}

export const initialPlanState: PlanState = {
  planList: [],
  planDetail: null,
  selectedPlanForCheckout: null
};

export const planSlice = createSlice({
  name: "plans",
  initialState: initialPlanState,
  reducers: {
    setPlanList: (state, action: PayloadAction<Plan[]>) => {
      state.planList = action.payload;
    },
    resetPlanList: (state) => {
      state.planList = initialPlanState.planList;
    },
    setPlanDetail: (state, action: PayloadAction<Plan | null>) => {
      state.planDetail = action.payload;
    },
    resetPlanDetail: (state) => {
      state.planDetail = initialPlanState.planDetail;
    },
    setSelectedPlanForCheckout: (
      state,
      action: PayloadAction<SelectedPlanForCheckout | null>
    ) => {
      state.selectedPlanForCheckout = action.payload;
    }
  }
});

export const {
  setPlanList,
  resetPlanList,
  setPlanDetail,
  resetPlanDetail,
  setSelectedPlanForCheckout
} = planSlice.actions;

export default planSlice.reducer;
